import {Component, Inject, Input} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {IAppliedFiltersUpdater, IAppliedFiltersUpdaterToken} from '../../../applied-filters-updater';
import {AbstractFilterComponent} from '../../abstract-filter.component';
import {AdvancedFilterOperatorEnum, AdvanceFilterParamType} from '../../advance-filter';

@Component({
    selector: 'app-text-filter',
    templateUrl: './text-filter.component.html',
    styleUrl: './text-filter.component.scss',

})
export class TextFilterComponent extends AbstractFilterComponent<{availableOperators: AdvancedFilterOperatorEnum[]}>{

   @Input() get availableOperators(): AdvancedFilterOperatorEnum[] {
    return this.options?.availableOperators ||   [
           AdvancedFilterOperatorEnum.startsWith,
           AdvancedFilterOperatorEnum.contains,
           AdvancedFilterOperatorEnum.endsWith,
           AdvancedFilterOperatorEnum.eq,
           AdvancedFilterOperatorEnum.ne
       ];
   }

    constructor(
        _formBuilder: FormBuilder,
        @Inject(IAppliedFiltersUpdaterToken) filterUpdater: IAppliedFiltersUpdater<AdvanceFilterParamType>) {
        super(_formBuilder,filterUpdater );
    }

}
